module.exports = __webpack_public_path__ + "static/sport/left-bottom01.0e2af87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/left-bottom01.png
// module id = l4Xh
// module chunks = 0